import { userSchema } from './user.schema';
import { z } from 'zod';

export const editUserSchema = userSchema.extend({
  password: z.string().optional(),
});

export type TEditUserSchema = z.infer<typeof editUserSchema>;
